<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('events-panel')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Event</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Title"
          v-model="blog_data.title"
        >
        </base-input>
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Enter Text"
          v-model="blog_data.linktext"
        >
        </base-input>

        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        (Dimensions should H-700, W-900)
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <img v-if="image" :src="image" ref="cover" />
        <div class="mt-3 mb-4">
          <p class="mb-2">Uploaded Image</p>
          <img
            class="w-1/2"
            :src="$imageURL + '/' + selectedBlog.image"
            alt="uploaded-image"
          />
        </div>
        <!--  <quill-editor
          v-model="blog_data.html"
          :options="editorOption"
          class="quill-h200px my-2"
        /> -->
        <div class="py-4 customboxed">
          <p class="mb-1">Link</p>
          <base-input
            class="mb-3"
            name="URL"
            :rules="{ required: true }"
            placeholder="Add your URL"
            v-model="blog_data.link"
          >
          </base-input>
        </div>

        <!-- <b-form-group id="input-group-3" label="Tags:" label-for="input-3">
          <b-form-select id="input-3" v-model="selectedtag" required>
            <b-form-select-option :value="null" disabled
              >-- Please select an Tags --</b-form-select-option
            >
            <b-form-select-option
              v-for="(tag, indexOpt) in tags"
              :value="tag._id"
              :key="indexOpt"
              >{{ tag.name }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group> -->
        <!-- <div class="my-4">
          <base-input>
            <flat-picker
              placeholder="Select Date"
              v-model="blog_data.date"
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              required
              :config="{ allowInput: true }"
              class="form-control datepicker"
            >
            </flat-picker>
          </base-input>
        </div>
        <div class="my-4">
          <base-input>
            <flat-picker
              :config="configdateTimePicker"
              v-model="blog_data.time"
              name="Time"
              required
              class="w-full border p-2 rounded-lg"
              placeholder="Choose time"
            />
          </base-input>
        </div> -->
        <div class="flex">
          <div class="my-4 w-full flex">
            <div class="my-4 w-1/2 pr-2">
              <b-form-group label="Date:">
                <date-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  required
                  :config="{ allowInput: true }"
                  placeholder="Select Date"
                  v-model="blog_data.date"
                  class="cust-wfull"
                  valueType="format"
                >
                </date-picker>
              </b-form-group>
            </div>
            <div class="my-4 w-1/2 pl-2">
              <b-form-group label="Time:">
                <date-picker
                  v-model="blog_data.time"
                  format="HH:mm"
                  value-type="format"
                  type="time"
                  class="cust-wfull"
                  :config="configdateTimePicker"
                  placeholder="HH:mm"
                >
                </date-picker>
              </b-form-group>
            </div>
          </div>
        </div>

        <div class="mb-2">
          <b-form-group label="Tags:">
            <div class="md:flex justify-between items-center">
              <b-form-select v-model="tag1" required class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[0].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag1 in filter1"
                  :value="filtertag1._id"
                  :key="filtertag1._id"
                  >{{ filtertag1.name }}</b-form-select-option
                >
              </b-form-select>
              <b-form-select v-model="tag2" class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[1].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag2 in filter2"
                  :value="filtertag2._id"
                  :key="filtertag2._id"
                  >{{ filtertag2.name }}</b-form-select-option
                >
              </b-form-select>
              <b-form-select v-model="tag3" class="">
                <b-form-select-option :value="null" disabled>
                  Select {{ filters.length ? filters[2].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag3 in filter3"
                  :value="filtertag3._id"
                  :key="filtertag3._id"
                  >{{ filtertag3.name }}</b-form-select-option
                ></b-form-select
              >
            </div>
          </b-form-group>
        </div>
        <div class="mb-2">
          <b-form-checkbox
            id="checkbox-1"
            v-model="blog_data.onlyCorporateEvent"
          >
            <p>
              <strong>
                <p class="col-blk">
                  Click here to add event to Corporate Event.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>
        <div class="mb-2">
          <b-form-checkbox id="checkbox-2" v-model="isFeatured">
            <p>
              <strong>
                <p class="col-blk" @click="editModal = true">
                  Click here to feature this event.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>

        <div class="mb-2">
          <b-form-checkbox id="checkbox-3" v-model="blog_data.onlyRegistered">
            <p>
              <strong>
                <p class="col-blk">
                  Click here to restrict access to this event for registered
                  users only.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>

        <!-- <div class="mb-2">
          <b-form-checkbox id="checkbox-4" v-model="isSelected">
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this event on campaign.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div> -->
        <div class="mb-2 w-1/3">
          <label for="campaign">Campaigns:</label>
          <multiselect
            v-model="selectedCampaigns"
            :options="getCampaignOptions()"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :preselect-first="false"
            placeholder="Select Campaign"
            track-by="value"
            label="label"
          ></multiselect>
        </div>
        <div class="mb-2 w-1/3">
          <label for="membership">Membership:</label>
          <multiselect
            name="membership"
            v-model="selectedMembership"
            :options="membershipFilter"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Memberships"
            track-by="name"
            label="name"
            :preselect-first="false"
            :disabled="!blog_data.onlyRegistered ? true : false"
          >
          </multiselect>
        </div>
        <!-- <div class="grid grid-cols-2 gap-4 mt-3">
          <div>
            <p class="mb-1">Meta Title</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="blog_data.metaTitle"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Description</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="blog_data.metaDesc"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Canonical Tag</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="blog_data.metaCanonicalTag"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Keyword</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="blog_data.metaKeyword"
            >
            </base-input>
          </div>
        </div> -->

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";
import flatPicker from "vue-flatpickr-component";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "flatpickr/dist/flatpickr.css";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import _ from "lodash";
import { mapState } from "vuex";
import Data from "../../../../../admin/pages/add-course/components/Data";

export default {
  components: {
    FileUploader,
    quillEditor,
    flatPicker,
    DatePicker,
  },
  data() {
    return {
      title: "",
      image: "",
      coverImage: "",
      body: "",
      blog_data: {},
      editorOption: {
        theme: "snow",
      },
      filter1: [],
      filter2: [],
      filter3: [],
      Ctags: [],
      selectedCampaigns: [],
      campaignOptions: [],
      tag1: "",
      tag2: "",
      tag3: "",
      linktext: "",
      link: "",
      selectedtag: null,
      selectedUsers: null,
      selectedSeg: null,
      selectdate: "",
      selecttime: "",
      isSelected: false,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
      },
      isFeatured: false,
      selectedMembership: null,
      membershipFilter: [],
      onlyRegistered: false,
    };
  },
  computed: {
    ...mapState("cms", {
      filtertags: "filtertags",
      filters: "filters",
      selectedBlog: "selectedBlog",
      pageCategories: "pageCategories",
    }),
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
    ...mapState("campaignPageBanner", { campaignHome: "campaignHome" }),
    campaignHome() {
      return this.$store.state.campaignPageBanner.campaignHome || {};
    },
  },
  methods: {
    getCampaignOptions() {
      return this.campaignHome && this.campaignHome.result
        ? this.campaignHome.result.map((campaign) => ({
            label: campaign.heading,
            value: campaign._id,
          }))
        : [];
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.coverImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      if (!this.blog_data.onlyRegistered) {
        this.selectedMembership = null;
      }
      let FormData = require("form-data");

      this.Ctags.push(
        this.blog_data.tags[0],
        this.blog_data.tags[1],
        this.blog_data.tags[2]
      );
      let data = new FormData();

      data.append("_id", this.blog_data._id);
      data.append("title", this.blog_data.title);
      data.append("subTitle", "");
      data.append("media", this.coverImage);
      data.append("html", this.blog_data.html);
      data.append("tags", JSON.stringify(_.uniq(this.Ctags)));
      data.append("linktext", this.blog_data.linktext);
      data.append("link", this.blog_data.link);
      data.append("date", this.blog_data.date);
      data.append("time", this.blog_data.time);
      data.append("pageCategory", this.blog_data.pageCategory._id);
      data.append("isFeatured", this.isFeatured);
      // data.append("isSelected", this.isSelected);
      data.append(
        "selectedCampaigns",
        this.selectedCampaigns.map((campaign) => campaign.value)
      );
      data.append("onlyCorporateEvent", this.blog_data.onlyCorporateEvent);

      // data.append("metaKeyword", this.blog_data.metaKeyword);
      // data.append("metaCanonicalTag", this.blog_data.metaCanonicalTag);
      // data.append("metaDesc", this.blog_data.metaDesc);
      // data.append("metaTitle", this.blog_data.metaTitle);

      // let formObj = {};
      // for (var pair of data.entries()) {
      //   formObj[pair[0]] = pair[1];
      // }
      // console.log(formObj);

      data.append("memberships", JSON.stringify(this.selectedMembership));
      if (this.selectedMembership !== null) {
        data.append("onlySubscribed", true);
        data.append("onlyRegistered", true);
      } else {
        data.append("onlyRegistered", this.blog_data.onlyRegistered);
        data.append("onlySubscribed", false);
      }
      let loader = this.$loading();

      try {
        const editData = await this.$store.dispatch("cms/editPage", data);
        if (editData.code == 200) {
          //await this.$store.dispatch("cms/addPage", data);
          this.$router.push({ name: "events-panel" });
          this.$swal.fire({
            text: "Modification of event is successfully completed",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });

          loader.close();
          //await this.$store.dispatch("cms/addPage", data);
          this.$router.push({ name: "events-panel" });
          loader.close();
        }
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async gettagsbycategory() {
      this.filter1 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[0]._id
      );
      this.filter2 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[1]._id
      );
      this.filter3 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[2]._id
      );
      let filteredMembershipAPIData = await this.$store.dispatch(
        "subscribe/GetAllMembership"
      );
      this.membershipFilter = this.get_all_membership.filter((membership) => {
        if (
          membership.name.toLowerCase() !== "visitor" &&
          membership.name.toLowerCase() !== "registered"
        ) {
          return true;
        }
        return false;
      });
    },
    async init() {
      this.blog_data = { ...this.selectedBlog };
      this.tag1 = this.blog_data.tags[0];
      this.tag2 = this.blog_data.tags[1];
      this.tag3 = this.blog_data.tags[2];
      this.isFeatured = this.blog_data.isFeatured
        ? this.blog_data.isFeatured
        : false;
      // this.isSelected = this.blog_data.isSelected;
      if (this.blog_data.selectedCampaigns && this.campaignHome.result) {
        this.selectedCampaigns = this.blog_data.selectedCampaigns.map(
          (campaignId) => {
            const campaign = this.campaignHome.result.find(
              (c) => c._id === campaignId
            );
            return campaign
              ? { label: campaign.heading, value: campaign._id }
              : null;
          }
        );
        // .filter(Boolean);
      }
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.init();
    this.gettagsbycategory();
  },
  watch: {
    membershipFilter() {
      if (this.blog_data.memberships && this.blog_data.memberships.length > 0) {
        this.selectedMembership = this.membershipFilter.filter((membership) => {
          let data = this.blog_data.memberships.find(
            (member) => member._id === membership._id
          );
          // return this.blog_data.memberships.includes(membership._id);
          return data;
        });
        // console.log(this.selectedMembership);
      }
    },
  },
};
</script>
<style>
.cust-wfull {
  width: 100% !important;
}
</style>
